import React, {useEffect, useRef, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';

import Cookies from 'js-cookie';
import {API_CORE_URL, API_URL, validateForm} from 'constants/index.js';
import axios from 'axios';

import InputCustom from 'views/pages/components/InputCustom'
import InputFile from 'views/pages/components/InputFile'
import {InputArraySelect,} from 'views/pages/components/InputSelect'
import InputToggle from 'views/pages/components/InputToggle'

import {Card, CardBody, CardHeader, Col, Container, Row,} from "reactstrap";

import CardsHeader from 'layouts/Headers/CardsHeader.js';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import notify from "@utils/notify";

export default function UserEdit() {
  const { id } = useParams();
  const history = useHistory();
  const [isNotValid,  setIsNotValid] = useState(true);
  const [userDataDraft,  setUserDataDraft] = useState('');
  const [token, setToken] = useState('');
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);

  const [user, setUser] = useState('');

  const [errors, setErrors] = useState('');

  useEffect(() => {
    if (Cookies.get('grs_token')) {
      let grs_token = Cookies.get('grs_token');
      setToken(grs_token);
     const fetchData = async () => {
         const roleResponse = await axios({
             method: 'GET',
             url: API_CORE_URL + '/role',
             headers: {
                 Authorization: 'Bearer ' + token
             }
         })
         if (roleResponse.status === 200) {
             const data = roleResponse.data.data;
             setRoles(data);
         }
      const response = await axios({
        method: 'GET',
        url: API_CORE_URL + '/user/' + id,
        headers: {
            Authorization: 'Bearer ' + grs_token
        }
      })
         if (response.status === 200) {
             let data = response.data.data;
             let tempData = {
                 ...data,
                 role_id: data.roles && data.roles[0] ? data.roles[0].id : '',
             }
             setUser(tempData);
             setUserDataDraft(JSON.stringify(tempData))

         }
         const usersResponse = await   axios({
             method: 'GET',
             url: API_URL + '/get-gmail-users',
             headers: {
                 Authorization: 'Bearer ' + token
             },

         })
         if (usersResponse.status === 200) {
             setUsers(usersResponse.data.data)

         }
     }
        fetchData()
    }
  }, [])

  const updateUser = () => {
    let formData = new FormData();
    formData.append('name', user.name);
    formData.append('address', user.address);
    formData.append('postal_code', user.postal_code);
    formData.append('phone_number', user.phone_number);
    formData.append('email', user.email);
    formData.append('role_id', user.role_id ? user.role_id : user.roles && user.roles[0] ? user.roles[0].id : undefined);
    formData.append('photo', user.photo ? user.photo : '');
    formData.append('is_active', user.is_active);
    formData.append('is_driver', user.is_driver);
    formData.append('department_id', ['undefined', null, 'null', '-'].includes(user.department_id) ? '' : user.department_id);
    formData.append('password', user.password);
    formData.append('password_confirmation', user.password ? user.password_confirmation : user.password);
    formData.append('_method', 'PUT');

    axios({
      method: 'POST',
      url: API_CORE_URL + '/user/' + id,
      data: formData
    })
      .then(response => {
        if (response.status === 200) {
          let data = response.data;
          setErrors('');
          notify.success(data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        if (error.response && error.response.status === 422) {
          setErrors(error.response.data.errors)
          return
        }
        notify.warning(error.response && error.response.statusText);
      })
  }

  const handleChange = (files) => {
    setUser({
      ...user,
      photo: files[0]
    });
  }

  const goList = () => {
    history.push('/admin/user');
  }
  const checkDisabled = () => {
      const required = ['name','email']
      setIsNotValid(!validateForm(required,user));
      setIsNotValid(userDataDraft === JSON.stringify(user))
  }
  const goToEmailsList = () => {
      history.push({
          pathname: `/admin/user/mail-list`,
          state: {
              email: user.email
          }
      });
  }
  useEffect(()=>{
      checkDisabled()
  },[user,userDataDraft])
  return (
    <>
      <CardsHeader name="Admin" parentName="User Management" currentName="Edit User" />
      <Container className="mt--6 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>

                <Row>

                  <Col xs={8}>
                    <h1 className="mb-0  main-color">User Management</h1>
                  </Col>

                </Row>

              </CardHeader>

              <CardBody>

                <Card>

                  <CardHeader>

                   <Row>
                       <h2 className="surtitle mb-0">User information</h2>
                           {users.length > 0  ? users.findIndex(item=>item===user.email) > -1
                            && <h2 onClick={goToEmailsList}
                              className="ml-5 edit-comment mb-0 cursor-pointer">
                            See user emails</h2>  : null }
                   </Row>

                  </CardHeader>

              <CardBody>
                      <Row className={'phone-container'}>
                          <Col>
                              <InputCustom
                                  newLabel={`Name`}
                                  placeholder={`Name`}
                                  required
                                  checkValid={false}
                                  value={user && user.name ? user.name : ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      name: e.target.value
                                  })}
                                  invalid={errors && errors.name ? true : false}
                                  errorMessage={errors.name}
                              />
                              <InputCustom
                                  type={`email`}
                                  newLabel={`Email`}
                                  required
                                  checkEmail
                                  checkValid={false}
                                  placeholder={`Email`}
                                  value={user && user.email ? user.email : ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      email: e.target.value
                                  })}
                                  invalid={errors && errors.email? true: false}
                                  errorMessage={errors.email}
                              />
                              <InputArraySelect
                                  newLabel={`Role`}
                                  options={roles}
                                  value={user && user.role_id ? user.role_id : ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      role_id: e.target.value
                                  })}
                                  valueKey={`id`}
                                  labelKey={`name`}
                                  defaultOption={true}
                                  invalid={errors && errors.role_id? true: false}
                                  errorMessage={errors.role_id}
                              />
                              <InputFile
                                  label={`Profile photo`}
                                  placeholder={`Select file`}
                                  onChange={(e) => handleChange(e.target.files)}
                              />


                          </Col>
                          <Col>

                              <InputCustom
                                  newLabel={`Postal Code`}
                                  placeholder={`Postal Code`}
                                  value={user && user.postal_code ? user.postal_code : ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      postal_code: e.target.value
                                  })}
                                  invalid={errors && errors.postal_code? true: false}
                                  errorMessage={errors.postal_code}
                              />

                              {/**/}
                              <InputCustom
                                  type={`password`}
                                  newLabel={`Password`}
                                  placeholder={`Password`}
                                  value={user && user.password ? user.password: ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      password: e.target.value
                                  })}
                                  invalid={errors && errors.password? true: false}
                                  errorMessage={errors.password}
                              />
                              <InputCustom
                                  type={`password`}
                                  newLabel={`Confirm password`}
                                  placeholder={`Confirm password`}
                                  value={user && user.password_confirmation ? user.password_confirmation: ''}
                                  onChange={(e) => setUser({
                                      ...user,
                                      password_confirmation: e.target.value
                                  })}
                                  invalid={errors && errors.password_confirmation? true: false}
                                  errorMessage={errors.password_confirmation}
                              />
                             <Col>
                                 <InputToggle
                                     side
                                     label={`Is driver`}
                                     checked={user && user.is_driver ? true : false}
                                     onChange={() =>
                                         setUser({
                                             ...user,
                                             is_driver: user.is_driver === 1 ? 0 : 1
                                         })
                                     }
                                 />
                             </Col>
                          </Col>
                      </Row>


                    <div className="d-flex flex-row justify-content-end">
                        <ButtonContainer onClick={() => goList(true)}>Back to list</ButtonContainer>
                      <ButtonContainer reverse disabled={isNotValid} onClick={() => updateUser()}>Save</ButtonContainer>
                    </div>
                  </CardBody>
                </Card>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}